import { render, staticRenderFns } from "./majorManagement.vue?vue&type=template&id=001c1b6f&scoped=true&"
import script from "./majorManagement.vue?vue&type=script&lang=js&"
export * from "./majorManagement.vue?vue&type=script&lang=js&"
import style0 from "./majorManagement.vue?vue&type=style&index=0&id=001c1b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c1b6f",
  null
  
)

export default component.exports